import { applyConfiguredTheme, initializeThemeChangeOnSystemThemeChange } from '@/utils/themes.ts'

export function usePluginTheme(): void {
  applyConfiguredTheme()

  initializeThemeChangeOnSystemThemeChange()
}
